interface Props {
  title: string
}

const CaseSectionTitle = ({ title }: Props) => {
  return <h3 className='text-lg font-bold text-textBlack print:mb-3'>{title}</h3>
}

export default CaseSectionTitle
